var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Schema, type } from "@colyseus/schema";
/**
 * Synced layered-appearance ids (the paperdoll). Mirrors `CharacterAppearance` in
 * ../appearance.ts. `uint8` (1 byte) is used because every value is a small 0..24 id;
 * appearance is set once on join and is otherwise immutable in a session, so it costs
 * ~0 bytes on the per-tick movement patches.
 *
 * Lives in its own file so BOTH `state.ts` (Player) and `blackjack.ts` (Seat) can import
 * it without a circular dependency.
 *
 * NOTE: compiled with `tsc` (legacy decorators, useDefineForClassFields=false); must NOT
 * be transformed by esbuild/Vite — consumers import the built `dist/` output.
 */
export class Appearance extends Schema {
    constructor() {
        super(...arguments);
        this.head = 1;
        this.face = 0;
        this.skinTone = 0;
        this.hair = 1;
        this.hairColor = 1;
        this.backHair = 0;
        this.beard = 0;
        this.beardColor = 0;
        this.ears = 0;
        this.earsColor = 0;
        this.glasses = 0;
        this.glassesColor = 0;
        this.backAcc = 0;
        this.backAccColor = 0;
        this.top = 0;
        this.topColor = 0;
        this.bottom = 0;
        this.bottomColor = 0;
        this.shoes = 0;
        this.shoesColor = 0;
        this.hat = 0;
        this.hatColor = 0;
        this.mask = 0;
        this.maskColor = 0;
        this.weapon = 0;
    }
}
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "head", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "face", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "skinTone", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "hair", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "hairColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "backHair", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "beard", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "beardColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "ears", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "earsColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "glasses", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "glassesColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "backAcc", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "backAccColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "top", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "topColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "bottom", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "bottomColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "shoes", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "shoesColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "hat", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "hatColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "mask", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "maskColor", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Appearance.prototype, "weapon", void 0);
const FIELDS = [
    "head", "face", "skinTone", "hair", "hairColor", "backHair", "beard", "beardColor",
    "ears", "earsColor", "glasses", "glassesColor", "backAcc", "backAccColor",
    "top", "topColor", "bottom", "bottomColor", "shoes", "shoesColor", "hat", "hatColor",
    "mask", "maskColor", "weapon",
];
/** Apply a plain appearance object (from the DB / DTO) onto a schema instance. */
export function assignAppearance(dst, a) {
    for (const f of FIELDS)
        dst[f] = a[f];
}
/** Copy appearance ids from one instance to another (e.g. Player -> Seat on sit). */
export function copyAppearance(src, dst) {
    for (const f of FIELDS)
        dst[f] = src[f];
}
/** Read a synced Appearance schema into a plain object (e.g. server equip handlers). */
export function plainAppearance(src) {
    const out = {};
    for (const f of FIELDS)
        out[f] = src[f];
    return out;
}
//# sourceMappingURL=appearance.js.map